module.exports = __webpack_public_path__ + "static/media/step_011.40862f6c.jpeg";